import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";
import api, { API_BASE } from "@/lib/api";
import { Camera, X } from "lucide-react";

export default function GallerySection() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/gallery?limit=60"); setItems(data); } catch(e){}
  })(); }, []);

  if (items.length === 0) return null;

  return (
    <section id="gallery" data-testid="gallery-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 border-t border-[hsl(var(--border))]">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
        <div>
          <p className="text-xs tracking-[0.25em] text-[hsl(var(--muted-foreground))] flex items-center gap-2"><Camera className="w-3.5 h-3.5" />{t.gallery.eyebrow}</p>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-3">{t.gallery.title}</h2>
        </div>
        <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-md">{t.gallery.sub}</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-testid="gallery-grid">
        {items.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => setOpen(p)}
            data-testid={`gallery-thumb-${p.id}`}
            className="group relative aspect-square overflow-hidden rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--muted))] focus:outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]"
          >
            <img src={`${API_BASE}/gallery/${p.id}/image`} alt={p.caption || "studio photo"} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
            {(p.caption || p.caption_zh) && (
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                <p className="text-xs text-white line-clamp-2">{lang==="zh" && p.caption_zh ? p.caption_zh : p.caption}</p>
              </div>
            )}
          </button>
        ))}
      </div>

      {open && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-center justify-center p-6" onClick={() => setOpen(null)}>
          <button type="button" data-testid="gallery-lightbox-close" className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setOpen(null)}><X className="w-6 h-6" /></button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={`${API_BASE}/gallery/${open.id}/image`} alt={open.caption || ""} className="w-full max-h-[80vh] object-contain rounded-2xl" />
            {(open.caption || open.caption_zh) && (
              <p className="mt-3 text-sm text-white/85 text-center">{lang==="zh" && open.caption_zh ? open.caption_zh : open.caption}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
